import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

export const roomsPrevScrollPosition: Writable<number> = writable<number>(0);

export const dashPrevScrollPosition: Writable<number> = writable<number>(0);

export const prevLocationPath: Writable<string> = writable<string>('');
